import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Loader2, Sparkles } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_f59c783b-4061-4c90-8631-f537af31e122/artifacts/nm25t9qa_Calcutta%20Logo.png";

export default function DemoAutoLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [err, setErr] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        await login("demo@calcutta.ip", "Demo@1234");
        nav("/dashboard", { replace: true });
      } catch (e) {
        setErr(formatApiError(e) || "Demo login failed. Please refresh and try again.");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6" data-testid="demo-auto-login">
      <div className="text-center max-w-md">
        <img src={LOGO} alt="Calcutta" className="w-14 h-14 rounded-sm mx-auto mb-5" />
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-sm bg-[#B33A3A] text-white mb-5">
          {err ? <Sparkles size={22} /> : <Loader2 size={22} className="animate-spin" />}
        </div>
        {!err ? (
          <>
            <h1 className="font-serif text-3xl font-semibold tracking-tight">Entering the demo…</h1>
            <p className="text-slate-500 text-sm mt-3">Signing you in as the Demo Account.</p>
          </>
        ) : (
          <>
            <h1 className="font-serif text-3xl font-semibold tracking-tight">Demo login failed.</h1>
            <p className="text-slate-500 text-sm mt-3">{err}</p>
            <p className="text-xs text-slate-400 mt-4">
              If this persists, hard-refresh the page (Ctrl/Cmd + Shift + R) to clear cached scripts.
            </p>
            <a href="/login" className="mt-5 inline-block text-sm text-[#B33A3A] hover:underline font-medium">
              Back to sign in →
            </a>
          </>
        )}
      </div>
    </div>
  );
}
